import { Component } from '@angular/core';
import { NavController, NavParams, Events } from 'ionic-angular';
import { SemovelProvider } from '../../providers/semovel/semovel';
import { ViewProvider } from '../../providers/view/view';
import { DadosProvider } from '../../providers/dados/dados';

@Component({
  selector: 'page-produto-view',
  templateUrl: 'produto-view.html',
})
export class ProdutoViewPage {
  produto: any;

  permitirDuvida:boolean = false;

  constructor(public navCtrl: NavController, public navParams: NavParams, public eve:Events, public server: SemovelProvider, private view:ViewProvider,
    private dadosProvider:DadosProvider) {
    this.produto = navParams.get('produto');
    this.permitirDuvida = dadosProvider.permitirDuvida;
  }

  ionViewDidLoad() {
  }

  adicionarCarrinho(unidade){
    this.eve.publish("carrinho:adicionar", this.produto, unidade);
  }

  avisar(){
    this.eve.publish("aviso:produto", this.produto);
  }

  getResposta(pergunta){
    if(!this.produto.respostas)  {
      return "";
    }
    let resposta = this.produto.respostas.find(
      (element) => {
        if(element.tipo_id == pergunta.id){
          return true;
        }
        return false;
      }
    );

    if(resposta){
      return resposta.resposta;
    }

    return "";
  }

  queroSaber(pergunta){
    console.log(pergunta);

    this.server.postData(
      {method:"quero_saber"}, {produto_id:this.produto.id, pergunta_id:pergunta.id}
    ).subscribe(
      (dados)=>{
        this.view.showMessage(dados.mensagem);
      },
      (err) => console.error(err)
    );
    // "Dúvida enviada com sucesso. O quanto antes iremos respondê-la."
  }

  perguntar(){
    this.view.showInput("Ainda tenho dúvidas.","O que você deseja saber sobre o produto?", (data) =>{
      // this.view.showMessage("Dúvida enviada com sucesso. O quanto antes iremos tirar sua dúvida.");
      if(!data || !data.informacao){
        return;
      }
      
      this.server.postData({method:"perguntar"}, {produto_id:this.produto.id, pergunta:data.informacao})
      .subscribe(
        (dados)=>{
          this.view.showMessage(dados.mensagem);
        },
        (err) => console.error(err)
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/produto-view/produto-view.ts